import dynamic from "next/dynamic";
import React, { useState, useEffect, useMemo, useRef } from "react";

let imageLinkSource = "s";
const importUnidit = () => import("@techzolab/zodit-react");

const UniditEditor = dynamic(importUnidit, {
  ssr: false,
});

import MyGallery from "./MyGallery";

function called() {
  let data = document
    .querySelector('button[name="insertimages"]')
    .getAttribute("data-srclink");

  // console.log(arguments[0].s.insertImage(data));

  // arguments[0].e.s.insertHtml("ddd");
}

export const fileBrows = (editor) => {
  document.querySelector('button[name="uniImageUploader"]').click();
  document
    .querySelector('button[name="insertimages"]')
    .addEventListener("click", called.bind(editor, editor));
};

export const fileBrows2 = (editor) => {
  document.querySelector('button[name="uniImageUploader"]').click();

  document
    .querySelector('button[name="insertimages"]')
    .addEventListener("click", function() {
      let data = document
        .querySelector('button[name="insertimages"]')
        .getAttribute("data-srclink");

      if (data != null && data != "undefined" && data != "") {
        let img = `<img src="` + data + `" alt="ddd" width="300px">`;
        // console.log(editor);

        // editor1.s.insertHTML(`<p>` + img + `</p>`);
      }
    });
};
export const fileBrows1 = (editor) => {
  const editor1 = editor;
  document.querySelector('button[name="uniImageUploader"]').click();
  document
    .querySelector('button[name="insertimages"]')
    .addEventListener("click", function() {
      document
        .querySelector('button[name="insertimages"]')
        .addEventListener("click", function() {
          if (data != null && data != "undefined" && data != "") {
            imageLinkSource = `<p>` + data + `</p>`;

            return;
          } else {
            return false;
          }
        });
    });

  // editor.s.insertHTML("hello");
  // editor.s.insertHTML("ddd");
  //   let data = document
  //   .querySelector('button[name="insertimages"]')
  //   .getAttribute("data-srclink");
  // if (data != null && data != "undefined" && data != "") {
  //   let img = `<p><img src="` + data + `"  width="300px"></p>`;
  //   console.log(editor.selection.insertHTML("dd"));
  //   // editor.s.insertHTML(`<p>` + img + `</p>`);
  //   return;
  // } else {
  //   return false;
  // }
};

const buttons = [
  "undo",
  "redo",
  "|",
  "bold",
  "strikethrough",
  "underline",
  "italic",
  "|",
  "superscript",
  "subscript",
  "|",
  "align",
  "|",
  "ul",
  "ol",
  //   "outdent",
  //   "indent",
  "justify",
  "|",
  "font",
  "fontsize",
  "brush",
  "paragraph",
  "|",
  "image",
  {
    name: "gallery",
    tooltip: "Uni gallery",
    iconURL:
      "data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIj48dGl0bGU+UGhvdG88L3RpdGxlPjxnIGlkPSJQaG90byIgc3Ryb2tlPSIjNEE0QTRBIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHJlY3QgaWQ9IlJlY3RhbmdsZS0xNiIgeD0iMi41IiB5PSIyLjUiIHdpZHRoPSIxOSIgaGVpZ2h0PSIxOSIgcng9IjIiLz48cGF0aCBpZD0iUGF0aC05IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkPSJNNC44NjggMTlsMy43NjYtOS4wNDggNC4yMyA3LjQzNiAyLjQwNC00LjAwN0wxOS4wNjIgMTl6Ii8+PGNpcmNsZSBpZD0iT3ZhbCIgY3g9IjE2IiBjeT0iNy4xMzMzMzMzMyIgcj0iMi4xMzMzMzMzMyIvPjwvZz48bWV0YWRhdGE+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIiB4bWxuczpyZGZzPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwLzAxL3JkZi1zY2hlbWEjIiB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iPjxyZGY6RGVzY3JpcHRpb24gYWJvdXQ9Imh0dHBzOi8vaWNvbnNjb3V0LmNvbS9sZWdhbCNsaWNlbnNlcyIgZGM6dGl0bGU9InBob3RvIiBkYzpkZXNjcmlwdGlvbj0icGhvdG8iIGRjOnB1Ymxpc2hlcj0iSWNvbnNjb3V0IiBkYzpkYXRlPSIyMDE4LTA2LTI4IiBkYzpmb3JtYXQ9ImltYWdlL3N2Zyt4bWwiIGRjOmxhbmd1YWdlPSJlbiI+PGRjOmNyZWF0b3I+PHJkZjpCYWc+PHJkZjpsaT5BdmluYXNoIFA8L3JkZjpsaT48L3JkZjpCYWc+PC9kYzpjcmVhdG9yPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L21ldGFkYXRhPjwvc3ZnPg==",
    exec: (editor) => {
      fileBrows(editor);
    },
  },
  "link",
  "table",
  "|",
  "hr",
  "eraser",
  "copyformat",
  "|",
  "selectall",
  "print",
  "|",
  "source",
  "|",
  "fullsize",
];

const editorConfig = {
  readonly: false,
  // events: {  afterInit: (instance) => {
  //   editorInstance = instance
  // } },
  toolbar: true,
  spellcheck: true,
  language: "en",
  toolbarButtonSize: "medium",
  toolbarAdaptive: false,
  showCharsCounter: true,
  showWordsCounter: true,
  showXPathInStatusbar: false,
  askBeforePasteHTML: true,
  askBeforePasteFromWord: true,
  //defaultActionOnPaste: "insert_clear_html",
  buttons: buttons,
  uploader: {
    insertImageAsBase64URI: true,
  },
  width: 800,
  height: 300,
};

export const UniEditorDefault = ({
  name,
  contents,
  onChange,
  height = 100,
  width = "100%",
  size = false,
  placeholder,
}) => {
  const editor = useRef(null);
  useEffect(() => {
    setValue(contents || ``);
  }, [contents]);

  editorConfig.width = width;
  editorConfig.height = height;

  const initialContent = contents ?? ``;
  const [value, setValue] = useState(initialContent);
  const isSSR = typeof window === "undefined";
  const target_name = name || "description";
  const [srcImage, setSrc] = useState(null);

  return (
    <>
      {!isSSR && (
        <React.Suspense fallback={<div>Loading RTE</div>}>
          <UniditEditor
            ref={editor}
            config={editorConfig}
            value={initialContent}
            onChange={(val) => {
              setValue(val);
              if (onChange) {
                const target = { name: target_name, value: val };
                onChange({ target });
              }
            }}
          />
        </React.Suspense>
      )}
      <MyGallery
        name="uniImageUploader"
        onChange={(event) => {
          setSrc(event.target.src);
        }}
      />
    </>
  );
};
export default UniEditorDefault;
